/**
 * Firebase Auth error handling utilities
 * Moved to shared layer as multiple features need auth error handling
 */

// Map Firebase error codes to user-friendly messages for sign in
export const getSignInErrorMessage = (errorCode: string): string => {
  const errorMessages: Record<string, string> = {
    'auth/user-not-found': 'No account found with this email address',
    'auth/wrong-password': 'Incorrect password',
    'auth/invalid-email': 'Invalid email address',
    'auth/user-disabled': 'This account has been disabled',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later',
    'auth/invalid-credential': 'Invalid credentials'
  };

  return errorMessages[errorCode] || 'Failed to sign in. Please try again.';
};

// Map Firebase error codes to user-friendly messages for sign up
export const getSignUpErrorMessage = (errorCode: string): string => {
  const errorMessages: Record<string, string> = {
    'auth/email-already-in-use': 'An account with this email already exists',
    'auth/invalid-email': 'Invalid email address',
    'auth/operation-not-allowed': 'Email/password accounts are not enabled',
    'auth/weak-password': 'Password should be at least 6 characters',
    'auth/network-request-failed': 'Network error. Please check your connection'
  };

  return errorMessages[errorCode] || 'Failed to create account. Please try again.';
};

// Map Firebase error codes to user-friendly messages for Google sign in
export const getGoogleSignInErrorMessage = (errorCode: string): string => {
  const errorMessages: Record<string, string> = {
    'auth/popup-closed-by-user': 'Sign in cancelled',
    'auth/popup-blocked': 'Popup was blocked by the browser',
    'auth/cancelled-popup-request': 'Sign in was cancelled',
    'auth/network-request-failed': 'Network error. Please check your connection'
  };

  return errorMessages[errorCode] || 'Failed to sign in with Google. Please try again.';
};

// Map Firebase error codes to user-friendly messages for password reset
export const getPasswordResetErrorMessage = (errorCode: string): string => {
  const errorMessages: Record<string, string> = {
    'auth/user-not-found': 'No account found with this email address',
    'auth/invalid-email': 'Invalid email address'
  };

  return errorMessages[errorCode] || 'Failed to send password reset email. Please try again.';
};
